import Vue from 'vue';

const state = {
  isLoading: false,
  loadingMessage: 'Carregando...',
  activeRequests: 0,
};

const getters = {
  isLoading: state => state.isLoading,
  loadingMessage: state => state.loadingMessage,
};

const actions = {
  showLoading({ commit }, message = 'Carregando...') {
    commit('SET_LOADING_MESSAGE', message);
    commit('INCREMENT_ACTIVE_REQUESTS');
  },
  
  hideLoading({ commit }) {
    commit('DECREMENT_ACTIVE_REQUESTS');
  },
  
  setLoadingMessage({ commit }, message) {
    commit('SET_LOADING_MESSAGE', message);
  },
};

const mutations = {
  SET_LOADING_MESSAGE(state, message) {
    state.loadingMessage = message;
  },
  
  INCREMENT_ACTIVE_REQUESTS(state) {
    state.activeRequests++;
    state.isLoading = state.activeRequests > 0;
  },
  
  DECREMENT_ACTIVE_REQUESTS(state) {
    state.activeRequests = Math.max(0, state.activeRequests - 1);
    state.isLoading = state.activeRequests > 0;
  },
  
  RESET_LOADING(state) {
    state.activeRequests = 0;
    state.isLoading = false;
    state.loadingMessage = 'Carregando...';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};